import { useProjectUsage } from 'modules/billing/hooks/useProjectUsage';
import { CUSTOM_EVENTS_METRICS } from '../../constants';
import { queryByFn } from '../../utils';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { ProjectUsagePageActions } from './ProjectUsagePageActions';
import { createRowCell } from './TableCell';

export const CUSTOM_EVENTS_PROJECT_USAGE_TEXT = {
  pageTitle: 'Custom events usage',
};

export const metricNames = [CUSTOM_EVENTS_METRICS.totalCustomEvents];

export const CustomEventsProjectUsage = () => {
  const { breadcrumb, columns, isLoading, rows } = useProjectUsage(metricNames);

  return (
    <SimpleIndexPage
      breadcrumb={breadcrumb}
      columns={columns}
      createRowCell={createRowCell}
      isLoading={isLoading}
      pageActions={<ProjectUsagePageActions />}
      pageTitle={CUSTOM_EVENTS_PROJECT_USAGE_TEXT.pageTitle}
      queryByFn={queryByFn}
      rows={rows}
    />
  );
};
